import { useLazyLoadQuery } from "react-relay"
import { CacheConfig, FetchPolicy, graphql, RenderPolicy } from "relay-runtime"
import { useTreatmentPlanTemplatesByIcdCodeQuery as useTreatmentPlanTemplatesByIcdCodeQueryType } from "@/modules/patients/detail/episode-of-care/services/__generated__/useTreatmentPlanTemplatesByIcdCodeQuery.graphql"
import { Country } from "@/types/__generated__/union-types"

const query = graphql`
  query useTreatmentPlanTemplatesByIcdCodeQuery($diagnosisCode: String!, $country: Country!) {
    treatmentPlanTemplatesByIcdCode(diagnosisCode: $diagnosisCode, country: $country) {
      id
      name
      amountOfDays
      asynchronousQuestionnaireUsage
      languages {
        language
        title
        synonym
        recommendedTreatment
        followUpInstructions
      }
    }
  }
`

const useTreatmentPlanTemplatesByIcdCodeQuery = (
  diagnosisCode: string,
  country: Country,
  options?: {
    fetchKey?: string | number | undefined
    fetchPolicy?: FetchPolicy | undefined
    networkCacheConfig?: CacheConfig | undefined
    UNSTABLE_renderPolicy?: RenderPolicy | undefined
  },
) => {
  const { treatmentPlanTemplatesByIcdCode } = useLazyLoadQuery<useTreatmentPlanTemplatesByIcdCodeQueryType>(
    query,
    {
      diagnosisCode,
      country,
    },
    {
      ...options,
    },
  )

  return treatmentPlanTemplatesByIcdCode
}

export { useTreatmentPlanTemplatesByIcdCodeQuery }
